import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 66.67%;

  background-color: ${(props) => props.theme.colors.greys.lightest};

  border-radius: 8px;
  border: solid 1px ${(props) => props.theme.colors.greys.lighty};

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;

  gap: 8px;
`;

export const FileSizeContainer = styled.div`
  /* text-wrap: nowrap; */
  white-space: nowrap;
`;

export const CellContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
`;

export const LoaderContainer = styled.div`
  width: fit-content;
  margin-bottom: 24px;

  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colors.greys.lighter};
`;

export const StatusContainer = styled.div`
  height: 28px;
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: space-between;
`;

export const StoreNameContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

export const DropdownContainer = styled.div`
  width: 100%;
  height: 100%;

  > div:first-child > div:first-child {
    border-style: none;
    border-radius: 0;
    height: 100%;

    ${({ isDisabled, theme }) =>
      isDisabled &&
      css`
        background-color: ${theme.colors.greys.lighter};
      `}
  }
`;

// MUI styles
const BASE_TABLE_CELL_SX = (theme) => ({
  width: 228,
  padding: 0,
  position: 'relative',
  borderRight: `1px solid ${theme.colors.greys.lighty}`,
});

export const getStoreTableCellSX = (theme, error = false) => ({
  ...BASE_TABLE_CELL_SX(theme),
  borderLeft: `1px solid ${theme.colors.greys.lighty}`,
  ...(error && {
    border: `1px solid ${theme.colors.infoRed}`,
  }),
});

export const getSupplierTableCellSX = (theme, error = false) => ({
  ...BASE_TABLE_CELL_SX(theme),
  ...(error && {
    border: `1px solid ${theme.colors.infoRed}`,
  }),
});

export const tableCellStoreNameCustomStyle = {
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2, // Limit to 2 lines
  textOverflow: 'ellipsis',
  wordBreak: 'break-word', // Break long words
  overflowWrap: 'break-word', // Fallback for long unbroken text
};
